import { getRoleName } from "@/utility/common";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const useColumnDefinitions = (listOfRecentUserIds: string[]) => {
  const user = useSelector((state: any) => state.user);

  const { t } = useTranslation();
  const usersListHeader = [
    {
      suppressHeaderMenuButton: true,
      field: "displayName",
      type: "displayNameType",
      comparator: () => 0,
      headerName: t("pages.userManagementPage.columnDetails.userName"),
      sortable: true,
      unSortIcon: true,
      autoHeight: true,
      textWrap: true,
      headerComponentParams: {
        enableSorting: true,
        showFilter: false,
      },
      editable: false,
      resizable: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 2,
      cellRenderer: "displayNameRenderer",
      cellRendererParams: {
        listOfRecentUserIds,
      },
    },
    {
      cellRenderer: "createdOnRenderer",
      type: "lastUpdatedDateType",
      comparator: () => 0,
      field: "lastUpdatedDate",
      headerName: t("pages.userManagementPage.columnDetails.addedOn"),
      flex: 2,
      sortable: true,
      suppressCellFocus: false,
      suppressHeaderMenuButton: true,
      resizable: false,
      unSortIcon: true,
      autoHeight: true,
      textWrap: true,
      editable: false,
    },
    {
      cellRenderer: (params: any) => {
        return t(getRoleName(params.data.applicationRole));
      },

      field: "applicationRole",
      type: "applicationRoleType",
      comparator: () => 0,
      flex: 2,
      headerName: t("pages.userManagementPage.columnDetails.applicationRole"),
      sortable: true,
      editable: (params: any) => {
        return params.data.oid !== user.id;
      },
      unSortIcon: true,
      suppressCellFocus: true,
      suppressHeaderMenuButton: true,
      resizable: true,
      cellEditor: "agSelectCellEditor",
      cellEditorParams: (e: any) => {
        return {
          values: [0, 1, 2],
        };
      },
      refData: {
        0: t("pages.userManagementPage.basicUser"),
        1: t("pages.userManagementPage.caseCreator"),
        2: t("pages.userManagementPage.systemAdmin"),
      },
    },
    {
      cellRenderer: "actionCellRenderers",
      field: "",
      flex: 1,
      headerName: "",
      sortable: false,
      editable: false,
      suppressCellFocus: false,
      suppressHeaderMenuButton: true,
      resizable: false,
      cellClass: "align-right",
    },
  ];
  return usersListHeader;
};

export default useColumnDefinitions;
